import { WalletType } from '@web3/base-utils';

export enum LoginStatus {
  NOT_READY,
  NONE,
  NOT_TARGET_TYPE,
  ONLY_SPOT,
  ONLY_WALLET,
  BOTH,
}

export enum UserStatus {
  NOT_READY,
  NOT_REGISTER, // 未报名
  WALLET_NOT_BINDING, // spot报名钱包未绑定
  SPOT_NOT_BINDING, // wallet报名spot未绑定
  WALLET_FINISH, // wallet为主账号已绑定
  SPOT_FINISH, // spot为主账号已绑定
}

export type GetSignParams = {
  chainCode: string;
  walletAddress: string;
  language: string;
};

export type GetSignRes = {
  chainCode: string;
  walletAddress: string;
  message: string;
};

export type GetRegisterStatusParams = {
  activityCode?: string;
  walletId?: string;
  walletType?: WalletType;
  userId?: string;
};

export enum RegisterStatus {
  NOT = 0,
  YES = 1,
}

export type GetRegisterStatusRes = {
  registerStatus: RegisterStatus;
  bindId: string;
};

export type GetRegisterParams = {
  activityCode?: string;
  walletId?: string;
  walletType?: WalletType;
  walletAddress?: string;
  userId?: string;
  email?: string;
};

export type GetRegisterRes = {};

export type GetBindingParams = {
  activityCode?: string;
  walletId: string;
  walletType: WalletType;
  walletAddress: string;
  chainCode: string;
  userId: string;
  email: string;
  sign: string;
  message: string;
};

export type GetBindingRes = {};
